






























import { Base } from "@/base";
import { Prop } from 'vue-property-decorator'
import Component from "vue-class-component";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

@Component({
  name: 'TheCardInfo',
  components: {
    PulseLoader
  }
})
export default class TheCardInfo extends Base {
  @Prop({default: ''}) color;
  @Prop({default: ''}) count;
  @Prop({default: ''}) info;
  @Prop({default: ''}) icon;
  @Prop({default: ''}) letter;
  @Prop({default: false}) edit;
  @Prop({default: false}) pending;
  @Prop({default: () => ({})}) isPending;
  @Prop({default: () => ({})}) action;
  @Prop({default: ''}) type;
  @Prop({default: ''}) address;
  // Methods
  editCard() {
    this.action(this.type);
  }
};
